<script>import { cn } from "../../utils/twClnm.js";
export let title = "";
export let textClass = "";
export let disabled = false;
export let variant = "default";
</script>

<button
	class={cn(
		'tw-inline-flex tw-h-9 tw-items-center tw-justify-center tw-gap-2.5 tw-rounded-2xl tw-px-5 tw-py-1.5',
		{
			'tw-bg-blue-600': variant === 'default',
			'tw-bg-rose-500': variant === 'danger',
			'tw-bg-green-500': variant === 'success',
			'tw-bg-yellow-500': variant === 'warning',
		},
		$$restProps.class,
		`${disabled ? "tw-opacity-50" : "tw-cursor-pointer"}`
	)}
	disabled={disabled}
	on:click
>
	<slot name="icon" />
	<span class={cn("tw-text-sm tw-font-medium tw-leading-tight tw-text-white", textClass)}
		>{title}</span
	>
	<slot name="iconLeft" />
</button>
